import diagramTranslate from "diagram-js/lib/i18n/translate";

import ColorContextPadProvider from "./ColorContextPadProvider";
import PopupMenuProvider from "./ColorPopupProvider";
import ColorRenderer from "./ColorRenderer";

export default {
  __depends__: [diagramTranslate],
  __init__: ["colorRenderer", "colorContextPadProvider", "colorPopupProvider"],
  colorRenderer: ["type", ColorRenderer],
  colorContextPadProvider: ["type", ColorContextPadProvider],
  colorPopupProvider: ["type", PopupMenuProvider],
};
